import { useState } from "react";
import useForm from '../../hooks/useForm';
import { FormField,  Modal, Button } from '@prosolve/common-components-ui'
import { isStarConsultation } from "../../utils";
import useDataSessions from "../../dataHooks/useDataSessions";
import { FaInfoCircle } from "react-icons/fa";
// import useDataAttendees from "../../../../dataHooks/useDataAttendees";

export default ({
  eventData,
  sessionData,
  onClose,
  onUpdate,
}) => {
  const isStarConsultationSession = isStarConsultation(eventData)

  const formSchema = isStarConsultationSession ?
  {
    requiredFields: [],
    optionalFields: ['schoolName', 'address', 'teacherName', 'teacherEmail', 'trainerLeadId', 'notes', 'classroomType'], // 'eventBlueprintDocument'
    initData: sessionData
  } :
  {
    requiredFields: [], //,'description'],
    optionalFields: ['location', 'trainerLeadId'], // 'eventBlueprintDocument'
    initData: sessionData
  };

  const formData = useForm(formSchema)

  const [isBusy, setIsBusy] = useState(false);

  const { updateSessions } = useDataSessions()

  const onClickSubmit = async () => {
    if (!isBusy && formData.isValid()) {
      setIsBusy(true) 
      
      try {
        const sessionSubmitData = { ...formData.values, _id: sessionData._id }

        const response = await updateSessions([sessionSubmitData])

        if (response.success) {
          onUpdate?.()
        }
      } catch (e) {
        console.log(e)
      } finally {
        setIsBusy(false)
      }

      onClose()
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Edit Session'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        { isStarConsultationSession &&
          <div style={{
            alignItems: 'center',
            background: '#F7F7F7',
            border: 'solid 1px silver',
            borderRadius: '5px',
            display: 'flex',
            gap: '10px',
            padding: '10px',
          }}>
            <FaInfoCircle style={{ fontSize: '26px', color: 'rgb(2, 128, 198)' }} />
            <div>
              <div>We recommend 2 teachers per day.</div>
              <div>If you want the same teacher for the full day please enter the same info for AM and PM.</div>
            </div>
          </div>
        }
        { !isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='location'
            type='text'
            label='Location'
            placeholder=''
            formData={formData}
          />
        }
        { isStarConsultationSession &&
          <>
          <FormField
            style={{ flex: 1 }}
            fieldId='schoolName'
            type='text'
            label='Name of School'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='address'
            type='text'
            label='Address'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='teacherName'
            type='text'
            label='Name of Teacher'
            placeholder=''
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='teacherEmail'
            type='text'
            label='Teacher Email'
            placeholder=''
            formData={formData}
          />
          </>
        }
        { isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='notes'
            type='text'
            label='Notes'
            placeholder=''
            formData={formData}
          />
        }
        { isStarConsultationSession &&
          <FormField
            style={{ flex: 1 }}
            fieldId='classroomType'
            type='text'
            label='Classroom Type'
            placeholder=''
            formData={formData}
          />
        }
      </div>
    </Modal>
  )
}